Asynchronously closes a live job ad.

The job ad will be removed from the job board and no refund will be issued.
The `PositionProfile` and its associated candidate applications will be available for 6 months after its close date.

Once the job ad has been closed a `PositionProfileClosed` event will be emitted.
